import styled from 'styled-components'

export const Container = styled.div`
    color: black;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    flex-direction: column;
    text-align: center;
`

export const BackGroundImage = styled.img`
    width: 33%;
    height: auto;
    align-self: center;
    padding-top: 10%;
`

export const GuidanceTitle = styled.h1<{
    color?: string
}>`
    color: ${({ color }) => color};
    padding: 10% 20% 0 20%;
`

export const GuidanceText = styled.p<{
    color?: string
}>`
    color: ${({ color }) => color};
    padding: 0 25% 10% 25%;
`
